import React, { useState, useEffect, Fragment, useRef } from 'react';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const GatesForm = ({
  handleValue = null,
  leadId,
  title = localization.promoterDetails,
  inputTitle = localization.tagNo,
  dropdownTitle = localization.gateFeature,
  handleDataFilter = null,
  handleremoveValue = null,
  noTag = false,
}) => {
  const objInput = { name: '', designation: '' };
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);

  const addGates = () => {
    if (!inputListData1.length || !inputListData2.length) {
      setIsError(true);
      return false;
    }

    setInputValue([...inputValue, { name: '', designation: '' }]);
    if (inputListData1?.id) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }

    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
  };
  const removeGate = (index = null) => {
    let removeArray = inputValue.splice(index + 1, 1);
    inputList.splice(index, 1);
    setInputValue([...inputValue]);
    setInputList([...inputList]);
    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };

  useEffect(() => {
    handleGates();
    if (handleDataFilter) {
      handleDataFilter(inputValue);
    }
  }, [inputValue]);

  const handleGates = (value) => {
    if (inputValue && handleValue) {
      for (const obj of inputValue) {
        if (obj.name === '') {
          return false;
        }
      }
      if (!leadId) {
        handleValue({
          promoters: [...inputValue],
        });
      } else {
        handleValue({
          promoters: [...inputValue],
          lead_id: leadId,
        });
      }
    }
  };
  const handleInitalValue = () => {
    setCatVal('');
    setNumberVal('');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };
  const handleInputValue = (val, key, index) => {
    const list = [...inputValue];
    list[index][key] = val;
    setInputValue([...list]);
  };

  return (
    <Fragment>
      <h5 className="w-100 row mx-0">{title}</h5>
      <div className="w-100 row mx-0">
        <div
          ref={inputRef.current[0]}
          className="row mx-0"
          disabled={catVal && numberVal ? true : false}
        >
          <ConstantInput
            label={localization.name}
            handleChange={(val) => {
              setCatVal(val.value);
              setInputListData1(val);
              setIsCurrentRef(0);
              handleInputValue(val, 'name', 0);
            }}
            errorMsg={localization.isRequired}
            required
            isStarRequired={true}
            value={catVal}
          />
          <ConstantInput
            label={localization.designation}
            errorMsg={localization.isRequired}
            type="text"
            required
            isStarRequired={true}
            handleChange={(val) => {
              setNumberVal(val);
              setInputListData2(val);
              setIsCurrentRef(0);
              handleInputValue(val, 'designation', 0);
            }}
            value={numberVal}
          />
        </div>
        <div>
          {inputList.length === 0 && catVal && numberVal ? (
            <Fragment>
              <ButtonWithIcon
                onClick={handleInitalValue}
                title={localization.clear}
              />
            </Fragment>
          ) : null}
        </div>
      </div>

      {inputList &&
        inputList.map((item, index) => {
          return (
            <div key={item.id} className="w-100 row mx-0">
              <div className="row mx-0" ref={inputRef.current[index + 1]}>
                <ConstantInput
                  label={localization.name}
                  handleChange={(val) => {
                    setInputListData1(val);
                    setIsCurrentRef(index + 1);
                    handleInputValue(val, 'name', index + 1);
                  }}
                  errorMsg={localization.isRequired}
                  required
                />
                <ConstantInput
                  label={localization.designation}
                  errorMsg={localization.isRequired}
                  type="text"
                  handleChange={(val) => {
                    setInputListData2(val);
                    setIsCurrentRef(index + 1);
                    handleInputValue(val, 'designation', index + 1);
                  }}
                />
              </div>
              <div>
                <a onClick={() => removeGate(index)} className="field-remove">
                  {localization.remove}
                </a>
              </div>
            </div>
          );
        })}
      <span>
        {isError ? (
          <label className="error d-block">{localization.enterField}</label>
        ) : null}
      </span>
      <div className="w-100 mb-20">
        <ButtonWithIcon title={localization.addMoreGates} onClick={addGates} />
      </div>
    </Fragment>
  );
};

export default GatesForm;
